import { gql } from '@apollo/client';
import { UPLOAD_FIELDS } from '../fragments';

export const CREATE_TOPIC = gql`
  mutation createTopic($input: CreateTopicInputType!) {
    createTopic(input: $input) {
      id
      title
      topicNo
      subjectId
      status
      updatedAt
      uploads {
        ...UploadFields
      }
    }
  }
  ${UPLOAD_FIELDS}
`;

/** Both ids: a topic is addressed within its subject's subcollection. */
export const UPDATE_TOPIC = gql`
  mutation updateTopic($subjectId: String!, $id: String!, $input: UpdateTopicInputType!) {
    updateTopic(subjectId: $subjectId, id: $id, input: $input) {
      id
      title
      topicNo
      subjectId
      video
      status
      content
      updatedAt
      uploads {
        ...UploadFields
      }
    }
  }
  ${UPLOAD_FIELDS}
`;

export const DELETE_TOPIC = gql`
  mutation deleteTopic($subjectId: String!, $id: String!) {
    deleteTopic(subjectId: $subjectId, id: $id)
  }
`;
